import { useMainStore } from '@/stores/main'
import { toLocaleCodes } from '@/utils/i18nLocales'
import { INDEX_ALLOWED_MODALS, isIndexScope } from '@/utils/modalScope'
import { resolveModalIntent } from '@/utils/urlModal'

// 首頁彈窗作用域：進入首頁時關閉不屬於首頁的彈窗（公告等 systemModal 與非白名單 modal）。
//
// 彈窗狀態存在 Pinia、renderer 常駐 layouts/default.vue，本身無路由生命週期，
// 從 /guest 觸發的公告會一路跟著跳回首頁，因此在路由層界定作用域。
//
// 為什麼是 afterEach 而不是 global middleware：middleware 寫進 store 的副作用不隨導航中止回滾。
// 已登入者進 /login、/register 會被 middleware/url-modal.global.js 的 abortNavigation() 或
// pages/index/ 的 guest middleware 攔下，在 middleware 層清窗會留下「頁面沒動、彈窗卻無聲消失」
// 的殘留。afterEach 的 failure 參數天然涵蓋所有被守衛中止的導航，不需要在本層複製登入判定。
export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const mainStore = useMainStore()

  // $i18n 在 plugin 建立當下未必就緒，取值延到 afterEach 觸發時
  const localeCodes = () => toLocaleCodes(nuxtApp.$i18n?.locales)

  router.afterEach((to, from, failure) => {
    // 導航沒有真的成立（abortNavigation、重複導航）→ 頁面還停在原處，不該動彈窗
    if (failure) return

    const locales = localeCodes()

    // 僅在「從首頁作用域之外進入」時清理：/ ↔ /login 互跳與 ?lang= 切語系（i18n-query
    // 的 navigateTo）都屬同一作用域內導航，一併清理會打斷正在進行的強制驗證流程
    if (!isIndexScope(to.path, locales) || isIndexScope(from.path, locales)) return

    mainStore.closeModalsExcept(INDEX_ALLOWED_MODALS)

    // urlModalPending 由 middleware/url-modal.global.js 在同一次導航的 beforeEach 寫入，
    // 本層晚於它，無條件清會把剛標記的旗標吃掉。只有目的地不會開窗時才清，
    // 淨效果與原本「middleware 先清、url-modal 隨後重設」相同
    if (!resolveModalIntent({ path: to.path, query: to.query, locales }).intent) {
      mainStore.setUrlModalPending(null)
    }
  })
})
